module.exports = __webpack_public_path__ + "img/custom_menu_view.3d1474fc.svg";